<template>
    <span>
        <div class="mb-3 vx-row">
            <div id="customer_details" class="w-full vx-col">
                <vx-card>
                    <div class="w-full con-expand-users">
                        <div class="flex items-center justify-between con-btns-user">
                            <div class="flex items-center justify-start con-userx">
                                <vs-avatar color="primary" :text="supplierDetails.company_name" />
                                <span class="font-semibold text-primary">
                                    {{ supplierDetails.company_name }}
                                    <span v-if="supplierDetails.code">({{ supplierDetails.code
                                    }})</span>
                                </span>
                            </div>
                            <span class="float-right text-xl font-bold">
                                Tenant Name:  <span class="text-warning">{{ tenant_details.name }}</span>
                            </span>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
        <vs-tabs v-on:input="onClickTabs" :value="active_step" :position="isSmallerScreen ? 'top' : 'left'"
            class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

            <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'General Details' : ''">
                <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
                    <ChanelPartnerProfileDetails :tenant_id="tenant_id" :partner_id="partner_id" />
                </div>
            </vs-tab>
            <vs-tab icon-pack="feather" icon="icon-circle" :label="!isSmallerScreen ? 'Customer Agreements' : ''">
                <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
                    <ChannelPartnerCustomerList :tenant_id="tenant_id" :partner_id="partner_id" />
                </div>
            </vs-tab>
            <!-- <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Raw Material' : ''">
                <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
                    <RawMaterialList :tenant_id="tenant_id" :supplier_id="supplier_id" />
                </div>
            </vs-tab> -->
        </vs-tabs>
    </span>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const SupplierRepository = RepositoryFactory.get('supplier')
const TenantRepository = RepositoryFactory.get('tenant')
const ChannelPartnerRepository = RepositoryFactory.get('channel_partner')
import ChanelPartnerProfileDetails from './tabs/ChanelPartnerProfileDetails.vue'
import ChannelPartnerCustomerList from './tabs/ChannelPartnerCustomerList.vue'
// import ManufactureList from './tabs/ManufactureList.vue'
// import RawMaterialList from './tabs/RawMaterialList.vue'
// import ProfileDetailsView from './tabs/ProfileDetailsView.vue'

export default {
    name: 'RmSupplierHome',
    components: {
        ChanelPartnerProfileDetails,
        ChannelPartnerCustomerList,
        // ManufactureList,
        // ProfileDetailsView,
        // RawMaterialList
    },
    data() {
        return {
            // active_step: this.$route.query.step ? this.$route.query.step : '0',
            supplierDetails: {
                company_name: '',
                account_number: ''
            },
            tenant_details: {
                name: 'loading..',
            },
            tenant_id: '',
            partner_id: '',
        }
    },
    async mounted() {
        // this.active_step = this.$route.query.step
        this.tenant_id = this.$route.params.id
        this.partner_id = this.$route.params.partner_id
        await this.fetchSupplierData()
        await this.fetchTenantDetails()
    },
    methods: {
        async fetchSupplierData() {
            const { data } = (await ChannelPartnerRepository.getChannelPartner(this.partner_id)).data
            this.supplierDetails = data
        },
        async fetchTenantDetails() {
            try {
                const { data } = (await TenantRepository.getTenantDetails(this.tenant_id)).data
                this.tenant_details = data
            } catch (e) {
                this.convertAndNotifyError(e)
            }
        },
        onClickTabs(step) {
            this.$router.push({ query: { step: step } }).catch(() => { });
        },
    },
    computed: {
        isSmallerScreen() {
            return this.$store.state.windowWidth < 768
        },
        active_step() {
            return this.$route.query.step ? this.$route.query.step : '0'
        }
    }
}
</script>
  
<style lang="scss">
#profile-tabs {
    .vs-tabs--content {
        padding: 0;
    }
}
</style>
  